import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCXY3dBUs3drBnT7VTx1q-MspdpggLqXBE",
  authDomain: "fintra-58b71.firebaseapp.com",
  projectId: "fintra-58b71",
  storageBucket: "fintra-58b71.appspot.com",
  messagingSenderId: "377326326994",
  appId: "1:377326326994:web:234f282c7036b3c6c8c90b"
};

// init firebase
firebase.initializeApp(firebaseConfig);

// init service
const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();

// timestamp
const timestamp = firebase.firestore.Timestamp;

export { projectFirestore, projectAuth, timestamp };